import PropTypes from 'prop-types'

import coveragesShape from './coveragesShape'
import dateShape from './dateShape'

export default PropTypes.shape({
  ancestors: PropTypes.arrayOf(PropTypes.string),
  ancestralHall: PropTypes.string,
  childCount: PropTypes.number,
  clan: PropTypes.string,
  coverages: PropTypes.arrayOf(coveragesShape),
  createdDate: dateShape,
  externalId: PropTypes.string,
  generationPoem: PropTypes.string,
  groupName: PropTypes.string,
  id: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.string),
  modifiedDate: dateShape,
  phoenixAcquisitionIds: PropTypes.arrayOf(PropTypes.string),
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  publicationDate: PropTypes.string,
  types: PropTypes.arrayOf(PropTypes.string),
  volumes: PropTypes.arrayOf(PropTypes.string),
  volumeSetTitle: PropTypes.string,
  volumeSetTotalVolumes: PropTypes.string,
})
